var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"columns is-multiline m-5"},_vm._l((_vm.articles),function(article){return _c('div',{key:article.id,staticClass:"column is-one-quarter"},[_c('ArticleCard',{attrs:{"article":article}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }